import { useState } from "react";
import { Steps } from "intro.js-react";
import { useSelector, useDispatch } from "react-redux";
import {
  getSelectedTour,
  getStartTour,
  removeTour,
  setStartTour,
  setCurrentStepIndex,
} from "@/store/slices/tour/tourSlice";
import useUserSettings, { SettingsKey } from "@/hooks/useUserSettings";


const TourWrapper = () => {
  const [initialStep, setInitialStep] = useState(0);
  const startTour = useSelector(getStartTour);
  const getSteps = useSelector(getSelectedTour);
  const dispatch = useDispatch();
  const { addUserSettings } = useUserSettings();

  const persistWelcomeOnTourFinish = () => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("blazeo_welcome_tour_pending") !== "true") return;
    sessionStorage.removeItem("blazeo_welcome_tour_pending");
    addUserSettings(SettingsKey.appointment_welcome, true);
  };

  const onExit = () => {
    // Loop through all steps
    getSteps.forEach((step) => {
      if (!step || !step.element || !step.activeElementClass) return;

      let element = null;

      if (typeof step.element === "string") {
        element = document.querySelector(step.element);
      } else if (step.element instanceof HTMLElement) {
        element = step.element;
      }

      if (element) {
        element.classList.remove(step.activeElementClass);
      }
    });

    const id = getSteps[0]?.id;
    let ele = document.getElementById(id);
    if (ele) ele.click();

    dispatch(setStartTour(false));
    dispatch(removeTour());
  };

  const [currentStep, setCurrentStep] = useState(0);

  const onBeforeChange = (nextStepIndex) => {
    // Remove class from current step (the one we are leaving)
    const prevStep = getSteps[currentStep];
    if (prevStep) {
      let prevElement = null;
      if (typeof prevStep.element === "string") {
        prevElement = document.querySelector(prevStep.element);
      } else if (prevStep.element instanceof HTMLElement) {
        prevElement = prevStep.element;
      }

      if (prevElement && prevStep.activeElementClass) {
        prevElement.classList.remove(prevStep.activeElementClass);
      }
    }

    // Add class to next step
    const nextStep = getSteps[nextStepIndex];
    if (!nextStep) return;

    let nextElement = null;
    if (typeof nextStep.element === "string") {
      nextElement = document.querySelector(nextStep.element);
    } else if (nextStep.element instanceof HTMLElement) {
      nextElement = nextStep.element;
    }

    if (nextElement && nextStep.activeElementClass) {
      nextElement.classList.add(nextStep.activeElementClass);
    }

    const isMovingBackward = nextStepIndex < currentStep;

    if (nextStep.scrollToElement !== false || isMovingBackward) {
      nextElement?.scrollIntoView({ behavior: "auto", block: "center" });
    }

    // Update current step both locally and in Redux (for sidebar to react)
    setCurrentStep(nextStepIndex);
    dispatch(setCurrentStepIndex(nextStepIndex));

    // Wait for scroll to finish
    return new Promise((resolve) => setTimeout(resolve, 200));
  };

  return (
    <div>
      <Steps
        enabled={startTour}
        steps={getSteps}
        initialStep={initialStep}
        onExit={onExit}
        onComplete={persistWelcomeOnTourFinish}
        onBeforeChange={onBeforeChange}
        options={{
          prevLabel: "Previous",
          showBullets: true,
          showStepNumbers: true,
          hidePrev: true,
          disableInteraction: true,
          exitOnEsc: false,
          exitOnOverlayClick: false,
          doneLabel: "Finish",
          scrollToElement: false,
        }}
      />
    </div>
  );
};

export default TourWrapper;
